import { createSelector } from '@reduxjs/toolkit';
import { getVehiclesById } from 'data/vehicles/selectors';
import { Map as ImmutableMap } from 'immutable';
import { DateTime } from 'luxon';
import type { RootState } from 'store';

import { REDUCER_KEY } from './reducer';

// @ts-expect-error FIXME TS7006
export const getTripsStore = (state) => state[REDUCER_KEY];
// @ts-expect-error FIXME TS7006
export const getTripsById = (state) => getTripsStore(state).resourcesById;
// @ts-expect-error FIXME TS7006
export const getTripsIsLoading = (state) => getTripsStore(state).isLoading;
export const getLastSyncDate = (state: RootState) => getTripsStore(state).lastSyncDate;

export const getSortedTripsById = createSelector(getTripsById, (tripsById) =>
  // @ts-expect-error FIXME TS7006
  tripsById.sort((a, b) => {
    if (DateTime.fromISO(a).toSeconds() > DateTime.fromISO(b).toSeconds()) {
      return -1;
    }
    return 1;
  }),
);

export const getTripsByVehicleId = createSelector(getTripsById, getVehiclesById, (tripsById, vehiclesById) =>
  ImmutableMap().withMutations((map) => {
    // @ts-expect-error FIXME TS7006
    vehiclesById.forEach((vehicle) => {
      map.set(
        vehicle.id,
        tripsById
          // @ts-expect-error FIXME TS7006
          .filter((x) => x.vehicleId === vehicle.id)
          .toList()
          // @ts-expect-error FIXME TS7006
          .sort((a, b) => {
            if (DateTime.fromISO(a).toSeconds() > DateTime.fromISO(b).toSeconds()) {
              return -1;
            }
            return 1;
          }),
      );
    });
  }),
);
